import React, { useState } from "react";
import { Card, Typography, Button, Result, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ClockCircleOutlined, HomeOutlined, CloseCircleOutlined } from "@ant-design/icons";
import Navbar from "./Navbar";
import GlobalButton from "../util/GlobalButton";
import UserServ from "../service/UserServ";
import { useGlobalAuthModal } from "../util/GlobalAuthModal";
import "../css/adminLayout.css"; // Reuse some layouts if needed

const { Title, Paragraph } = Typography;

const PendingSeller = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { showAlert } = useGlobalAuthModal();

    const handleCancelRequest = () => {
        showAlert({
            title: "Cancel Application?",
            description: "Are you sure you want to cancel your seller application? This will revert your account to a regular buyer.",
            buttons: [
                {
                    text: "No, Keep it",
                    onClick: () => console.log("Cancellation aborted")
                },
                {
                    text: "Yes, Cancel",
                    variant: "primary",
                    onClick: () => doCancel()
                }
            ]
        });
    };

    const doCancel = async () => {
        try {
            setLoading(true);
            const response = await UserServ.cancelSellerRequest();
            console.log("API Success Response:", response);

            // Update Local Storage
            localStorage.setItem("role", "user");
            const userData = localStorage.getItem("user");
            if (userData) {
                try {
                    const userObj = JSON.parse(userData);
                    userObj.role = "user";
                    localStorage.setItem("user", JSON.stringify(userObj));
                } catch (e) {
                    console.error("Storage update error:", e);
                }
            }

            message.success("Application cancelled successfully.");

            // Force refresh to Home
            setTimeout(() => {
                window.location.href = "/";
            }, 500);
        } catch (error) {
            console.error("API Error detected:", error);
            message.error(error?.message || "Failed to cancel application.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Navbar />
            <div
                style={{
                    minHeight: "calc(100vh - 80px)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "#f0f2f5",
                    padding: "20px"
                }}
            >
                <Card
                    style={{
                        maxWidth: 600,
                        width: "100%",
                        borderRadius: "16px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                        textAlign: "center",
                        padding: "40px 20px"
                    }}
                >
                    <Result
                        icon={<ClockCircleOutlined style={{ color: "var(--nearzon-orange)", fontSize: "64px" }} />}
                        title={<Title level={2}>Account Under Review</Title>}
                        subTitle={
                            <div style={{ fontSize: "16px", color: "#595959", marginTop: "10px" }}>
                                <Paragraph>
                                    Your seller application is currently being reviewed by our administration team.
                                    This process typically takes <strong>24-48 hours</strong>.
                                </Paragraph>
                                <Paragraph type="secondary">
                                    Once approved, you will have full access to the seller dashboard and can start listing your products.
                                </Paragraph>
                            </div>
                        }
                        extra={[
                            <div key="buttons" style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center" }}>
                                <GlobalButton
                                    action="submit"
                                    onClick={() => navigate("/")}
                                    style={{ width: "240px" }}
                                >
                                    <HomeOutlined /> Return to Home
                                </GlobalButton>

                                <Button
                                    danger
                                    icon={<CloseCircleOutlined />}
                                    onClick={() => {
                                        console.log("Button clicked!");
                                        handleCancelRequest();
                                    }}
                                    disabled={loading}
                                    style={{ width: "240px", height: "40px", borderRadius: "8px" }}
                                >
                                    {loading ? "Processing..." : "Cancel Application"}
                                </Button>

                                <Button
                                    type="link"
                                    onClick={() => {
                                        localStorage.clear();
                                        navigate("/seller-check");
                                    }}
                                    style={{ color: "#8c8c8c" }}
                                >
                                    Logout & Login with another account
                                </Button>
                            </div>
                        ]}
                    />
                </Card>
            </div>
        </>
    );
};

export default PendingSeller;
